// lib
import { useCallback } from 'react'
import PropTypes from 'prop-types'

// components
import JsonFileUpload from '@aytm/app/stats/page/xperts-debug/JsonFileUpload'
import LoaderDots from '@aytm/lib/rfd-ui/components/basic/loader-dots'

// styles
import style from '@aytm/app/stats/page/xperts-debug/XpertsDebugPopup.module.scss'

XpertsDebugPopup.propTypes = {
  text: PropTypes.string,
  maxItems: PropTypes.number,
  renderProgressText: PropTypes.func,
  multiple: PropTypes.bool,
  sortFiles: PropTypes.oneOf(['asis', 'asc', 'desc'])
  // onFilesUploaded: PropTypes.func.isRequired
}

const onFilesUploaded = files => {
  const [data] = files
  window.StatPage.model.xpertDebug = true // eslint-disable-line no-undef
  window.StatPage.model.set('refresh', true) // eslint-disable-line no-undef

  window.StatPage.survey.removeQuestions() // eslint-disable-line no-undef
  if (Array.isArray(data) && data.every(v => null !== v.schema && null !== v.data)) {
    const newData = {
      response: {
        aggregate: {
          schema: data.map(v => v.schema.id),
          scripts: {
            questions: data.reduce((acc, v) => Object.assign(acc, { [v.schema.id]: v.schema }), {})
          }
        },
        survey: {
          uid: Number(window.location.pathname.split('/')[2]).toString(36) + '@dev',
          questions: [],
          traits: [],
          schema: data.map(v => v.schema.id)
        },
        stats: data.reduce((acc, v) => Object.assign(acc, { [v.schema.id]: v.data.answer || v.data }), {})
      },
      status: 'OK'
    }
    window.StatPage.api.loadQuestionsSuccess()(null, newData) // eslint-disable-line no-undef
  } else if (data.aggregate && data.survey && data.stats) {
    window.StatPage.api.loadQuestionsSuccess()(null, data) // eslint-disable-line no-undef
  }

  const id = 'xperts-debug'
  const element = document.querySelector(`#${id}`)
  window.$STATS.unlinkComponent(element)
  element.remove(element)
}
export default function XpertsDebugPopup(props) {
  const { text, renderProgressText, multiple, sortFiles, maxItems } = props

  const renderButton = useCallback(
    ({ dragOver = false, progress, uploading } = {}) => (
      <div className={`${style.component}${dragOver ? ' ' + style.dragOver : ''}`}>
        {uploading && progress ? (
          <ProgressPanel progress={progress} renderProgressText={renderProgressText} />
        ) : (
          <DropPanel text={text || ''} />
        )}
      </div>
    ),
    [text, renderProgressText]
  )

  return (
    <JsonFileUpload
      maxItems={maxItems}
      multiple={multiple}
      sortFiles={sortFiles}
      watchProgress
      onFilesUploaded={onFilesUploaded}
      content={renderButton}
    />
  )
}

DropPanel.propTypes = {
  text: PropTypes.string.isRequired
}
export function DropPanel(props) {
  const { text } = props
  return (
    <div className={style.inner}>
      <div className={style.label}>
        <i className={style.icon} />
        <div className={style.text}>{text || ''}</div>
      </div>
    </div>
  )
}

ProgressPanel.propTypes = {
  renderProgressText: PropTypes.func,
  progress: PropTypes.object.isRequired
}
export function ProgressPanel(props) {
  const { progress = {}, renderProgressText } = props
  const { percents = 0, loadedFiles = 0, totalFiles = 1 } = progress || {}
  return (
    <div className={style.inner}>
      <div className={style.label}>
        <div className={style.uploadingPercents}>
          <LoaderDots dotSize={14} dots={3} height={40} /> {100 > percents ? `${percents}%` : ''}
        </div>
        {'function' == typeof renderProgressText ? (
          <div className={style.uploadingFiles}>{renderProgressText({ loadedFiles, totalFiles })}</div>
        ) : null}
      </div>
    </div>
  )
}
